/* eslint-disable init-declarations */
/* eslint-disable line-comment-position */
/* eslint-disable no-inline-comments */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import { Connection } from '../connection.class';
import { Connections } from '../connections.class';
import { Island } from '../../islands/island.class';
import { Islands } from '../../islands/islands.class';
import { moveSourceIslandCfn } from './move-source-island.cfn';

import { ConnectionHalfParams, ConnectionOptions } from '../types';
import { CORNER_THICKNESS, OVERHANG_REMOVAL_BY_MATERIAL } from '../../surround-material/constants';
import { Obstruction } from '../../obstructions/obstruction.class';
import { Panel } from '../../panels/panel.class';
import { Obstructions } from '../../obstructions/obstructions.class';
import { BlueprintInstanceType } from '../../shared.enums';

export type NewConnectionParams = {
	source: ConnectionHalfParams;
	target: ConnectionHalfParams;
	options: ConnectionOptions;
	islands: Islands;
	obstructions: Obstructions;
}

// eslint-disable-next-line max-len
export const newConnectionCfn = (connections: Connections, params: NewConnectionParams): void => {
	const {	source, target,	islands, obstructions, options } = params;

	// Get base finish from islands if available, otherwise default
	const baseFinish = islands?.refMap.kitchen?.material?.surround?.material ?? 'Stacked Stone';

	// Get source panel and entity
	let sourcePanel: Panel;
	let sourceEntity: Island | Obstruction;

	if (source.panel) {
		// Panel instance provided - get entity from panel's parent
		sourcePanel = source.panel;
		sourceEntity = (sourcePanel.findParentInstanceOf(BlueprintInstanceType.Island) ||
			sourcePanel.findParentInstanceOf(BlueprintInstanceType.Obstruction)) as unknown as Island | Obstruction;
		if (!sourceEntity) {
			throw new Error(`Source panel ${source.panelId} does not have a parent Island or Obstruction`);
		}
	} else {
		// Fall back to collection lookup
		const sourceIsland = islands?.findById(source.islandId) ?? null;
		if (sourceIsland) {
			sourcePanel = sourceIsland.panels.findById(source.panelId);
			sourceEntity = sourceIsland;
		} else {
			const sourceObstruction = obstructions?.findById(source.islandId) ?? null;
			if (!sourceObstruction) {
				throw new Error(`Source entity with id ${source.islandId} not found in islands or obstructions`);
			}
			sourcePanel = sourceObstruction.panels.findById(source.panelId) ?? sourceObstruction.panels.getFrontPanel();
			sourceEntity = sourceObstruction;
		}
	}

	// Get target panel and entity
	let targetPanel: Panel;
	let targetEntity: Island | Obstruction;

	if (target.panel) {
		// Panel instance provided - get entity from panel's parent
		targetPanel = target.panel;
		targetEntity = (targetPanel.findParentInstanceOf(BlueprintInstanceType.Island) ||
			targetPanel.findParentInstanceOf(BlueprintInstanceType.Obstruction)) as unknown as Island | Obstruction;
		if (!targetEntity) {
			throw new Error(`Target panel ${target.panelId} does not have a parent Island or Obstruction`);
		}
	} else {
		// Fall back to collection lookup
		const targetIsland = islands?.findById(target.islandId) ?? null;
		if (targetIsland) {
			targetPanel = targetIsland.panels.findById(target.panelId);
			targetEntity = targetIsland;
		} else {
			const targetObstruction = obstructions?.findById(target.islandId) ?? null;
			if (!targetObstruction) {
				throw new Error(`Target entity with id ${target.islandId} not found in islands or obstructions`);
			}
			targetPanel = targetObstruction.panels.findById(target.panelId) ?? targetObstruction.panels.getFrontPanel();
			targetEntity = targetObstruction;
		}
	}

	const newSourceConnection = new Connection({
		isSource: true,
		horizontalAlign: source.horizontalAlignment,
		verticalAlign: source.verticalAlignment,
		alignToPanel: source.alignToPanel ?? false,
		sourcePanelId: source.panelId,
		targetIslandId: target.islandId,
		padding: options.padding,
		offset: options.offset
	}, { parent: sourceEntity.connections as unknown as Connections });

	const newTargetConnection = new Connection({
		isSource: false,
		horizontalAlign: target.horizontalAlignment,
		verticalAlign: target.verticalAlignment,
		alignToPanel: target.alignToPanel ?? false,
		sourcePanelId: target.panelId,
		targetIslandId: source.islandId,
		padding: 0,
		offset: 0
	}, { parent: targetEntity.connections as unknown as Connections });


	const removeOverhang = OVERHANG_REMOVAL_BY_MATERIAL[baseFinish] ?? CORNER_THICKNESS;

	// trim countertop overhang
	// Always remove overhang when connecting to/from an obstruction
	if (targetEntity.instanceOf === BlueprintInstanceType.Obstruction) {
		sourcePanel.countertopOverhang = removeOverhang;
	} else if (sourceEntity.instanceOf === BlueprintInstanceType.Obstruction) {
		targetPanel.countertopOverhang = removeOverhang;
	} else if (sourcePanel.isSidePanel && targetPanel.isSidePanel) {
		// inline, shortest is trimmed to cornerthickness
		if (sourceEntity.size.height > targetEntity.size.height) {
			targetPanel.countertopOverhang = removeOverhang;
		} else {
			sourcePanel.countertopOverhang = removeOverhang;
		}
	} else if (sourcePanel.isSidePanel) {
		sourcePanel.countertopOverhang = removeOverhang;
	} else if (targetPanel.isSidePanel) {
		targetPanel.countertopOverhang = removeOverhang;
	}

	// add connection
	connections.children.push(newSourceConnection);

	const targetConnections = targetEntity.connections;
	targetConnections.deleteConnection(target.panelId, target.islandId);
	targetConnections.children.push(newTargetConnection as unknown as Connection);

	moveSourceIslandCfn(newSourceConnection as Connection);
	connections.addConnection(newSourceConnection as Connection);
}
